import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { EndpointService, HttpErrorHandlingService } from "@app/core";

@Injectable()
export class UsersTaskDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService,
    private hehs: HttpErrorHandlingService
  ) {}

  /**
   *Obtiene los usuarios de la tarea
   *
   * @return {*}  {Observable<any>}
   * @memberof UsersTaskDataService
   */
  getUsers(task_id: number): Promise<any> {
    return new Promise((resolve) => {
      this.http
        .get<any>(this.api.get("usersTask", [task_id]))
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            // console.log(err);
          }
        );
    });
  }

  /**
   *Obtiene los usuarios disponibles de los grupos de la tarea
   *
   * @return {*}  {Observable<any>}
   * @memberof UsersTaskDataService
   */
   getTaskGroupUsers(task_id: number): Promise<any> {
    return new Promise((resolve) => {
      this.http
        .get<any>(this.api.get("usersGroupTask", [task_id]))
        .subscribe(
          (res) => {
            resolve(res);
          },
          (err) => {
            // console.log(err);
          }
        );
    });
  }

  /**
   * Asigna usuarios responsables a la tarea
   *
   * @param {number} task_id
   * @param {number[]} responsible
   * @returns {Observable<boolean>}
   * @memberof UsersTaskDataService
   */
  addUsersTask(task_id: number, responsibles: number[]): Observable<boolean> {
    return new Observable(obs => {
      const formData = {
        accion: 'agregar',
        tarea: task_id,
        responsables: responsibles
      };
      this.http.post<any>(this.api.get('usersTask'), formData).subscribe(
        _data => {
          this.toastr.success(_data, 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Desasignar usuarios responsables a la tarea
   *
   * @param {number} task_id
   * @param {number[]} responsible
   * @returns {Observable<boolean>}
   * @memberof UsersTaskDataService
   */
  deleteUsersTask(task_id: number, responsibles: number[]): Observable<boolean> {
    return new Observable(obs => {
      const formData = {
        accion: 'eliminar',
        tarea: task_id,
        responsables: responsibles
      };
      this.http.post<any>(this.api.get('usersTask'), formData).subscribe(
        _data => {
          this.toastr.success(_data, 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/users-task-management/shared/users-task-management.data.service.ts